import { Event } from "src/app/domain/event"

export class CreateCustomEventsDto {
    Event?: Event;
    SamplerPuidList: string[] = [];
}